module.exports = __webpack_public_path__ + "img/savta_yes.ff07079e.png";